var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 14,
    viewBox: "0 0 61 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2882_76413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4546 8.12234C11.0641 8.23352 10.6519 8.29305 10.2258 8.29305C7.75286 8.29305 5.74812 6.28831 5.74812 3.81534C5.74812 3.37405 5.81196 2.94766 5.9309 2.54492H1.29125C0.57811 2.54492 0 3.12303 0 3.83617V12.7083C0 13.4214 0.57811 13.9995 1.29125 13.9995H10.1633C10.8765 13.9995 11.4546 13.4214 11.4546 12.7083V8.12234Z",
    fill: "#F5F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 3.18183C14.0004 4.93911 12.5758 6.36366 10.8186 6.36366C9.06127 6.36366 7.63672 4.93911 7.63672 3.18183C7.63672 1.42455 9.06127 0 10.8186 0C12.5758 0 14.0004 1.42455 14.0004 3.18183Z",
    fill: "url(#paint0_linear_2882_76413)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5799 9.07343V13.904H29.5859V9.07343C29.5859 6.10447 28.0453 4.1626 25.6059 4.1626C24.4183 4.1626 23.3591 4.86874 23.0061 5.84769V4.27494H21V13.904H23.0061V9.08948C23.0061 7.38834 23.9529 6.16866 25.2528 6.16866C26.6651 6.16866 27.5799 7.3081 27.5799 9.07343Z",
    fill: "#F5F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9268 9.07343C30.9268 11.8659 32.997 14.0003 35.6611 14.0003C38.3251 14.0003 40.3793 11.8659 40.3793 9.07343C40.3793 6.29705 38.3251 4.1626 35.6611 4.1626C32.997 4.1626 30.9268 6.29705 30.9268 9.07343ZM35.6611 6.16866C37.2017 6.16866 38.3733 7.42044 38.3733 9.07343C38.3733 10.7425 37.2017 11.9943 35.6611 11.9943C34.1204 11.9943 32.9328 10.7425 32.9328 9.07343C32.9328 7.42044 34.1204 6.16866 35.6611 6.16866Z",
    fill: "#F5F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2265 2.23682L42.7449 4.27498H41.3167V6.1687H42.7449V10.598C42.7449 12.9572 43.7079 13.904 46.0028 13.904H46.8373V11.914H46.1954C45.2004 11.914 44.751 11.4807 44.751 10.4857V6.1687H46.8373V4.27498H44.751V2.23682H43.2265Z",
    fill: "#F5F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2386 13.904V4.2749H48.2325V13.904H50.2386Z",
    fill: "#F5F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5157 13.9039V4.27485H54.9951V3.56872C54.9951 2.57372 55.4444 2.12435 56.4394 2.12435H57.0814V0.150391H56.2468C53.9519 0.150391 52.989 1.08121 52.989 3.45638V4.27485H51.5767V6.16857H52.989V13.9039H54.9951V6.16857H58.5097V13.9039H60.5157Z",
    fill: "#F5F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0032 0C48.4363 0 48.2324 0.311122 48.2324 0.753594V2.3621H49.8052C50.3514 2.3621 50.5945 2.17089 50.5945 1.63162V0.753594C50.5945 0.2489 50.2615 0 49.7499 0H49.0032Z",
    fill: "#F5F6FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2882_76413",
    x1: 12.74,
    y1: 0.49587,
    x2: 9.68218,
    y2: 6.36366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB776"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2882_76413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.de19bd8ca127732cfba937108cc0fea9.svg";
export { ForwardRef as ReactComponent };